import { useState } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useForm } from 'react-hook-form';
import { matchPath, useNavigate } from 'react-router-dom';
import Contaier from "../../components/layout/Container/Container";
import { IForcePassword } from '../../typings/models/ForcePassword';
import { defaultAppContextData } from "../../services/appData";
import { useApiService, useContextService } from "../../services";
import { notify } from '../../utils';
import { NotifyType, PageUrl } from '../../utils/app-config';
import Loader from '../../components/molecules/Loader';

function ForceChangePassword() {   
  const navigate = useNavigate();
  const { ForcePassword } = useApiService();
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const [loading, setLoading] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const { message } = notify();
  const user = contextData.user;
  const { register, handleSubmit, formState: { errors } } = useForm<IForcePassword>();

  const handleNewPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;
    const passwordLength =      value.length;
    const uppercasePassword =   uppercaseRegExp.test(value);
    const lowercasePassword =   lowercaseRegExp.test(value);
    const digitsPassword =      digitsRegExp.test(value);
    const specialCharPassword = specialCharRegExp.test(value);
    const minLengthPassword =   minLengthRegExp.test(value);
    let errMsg ="";
    if(passwordLength===0){
            errMsg="Password is empty";
            setIsButtonEnabled(false);
    }else if(!uppercasePassword){
            errMsg="At least one Uppercase";
            setIsButtonEnabled(false);
    }else if(!lowercasePassword){
            errMsg="At least one Lowercase";
            setIsButtonEnabled(false);
    }else if(!digitsPassword){
            errMsg="At least one digit";
            setIsButtonEnabled(false);
    }else if(!specialCharPassword){
            errMsg="At least one Special Characters";
            setIsButtonEnabled(false);
    }else if(!minLengthPassword){
            errMsg="At least minumum 8 characters";
            setIsButtonEnabled(false);
    }else{
        errMsg="";
        setIsButtonEnabled(true);
    }

    setNewPasswordError(errMsg);    
  };

  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;
    const passwordLength =      value.length;
    const uppercasePassword =   uppercaseRegExp.test(value);
    const lowercasePassword =   lowercaseRegExp.test(value);
    const digitsPassword =      digitsRegExp.test(value);
    const specialCharPassword = specialCharRegExp.test(value);
    const minLengthPassword =   minLengthRegExp.test(value);
    let errMsg ="";
    if(passwordLength===0){
            errMsg="Password is empty";
            setIsButtonEnabled(false);
    }else if(!uppercasePassword){
            errMsg="At least one Uppercase";
            setIsButtonEnabled(false);
    }else if(!lowercasePassword){
            errMsg="At least one Lowercase";
            setIsButtonEnabled(false);
    }else if(!digitsPassword){
            errMsg="At least one digit";
            setIsButtonEnabled(false);
    }else if(!specialCharPassword){
            errMsg="At least one Special Characters";
            setIsButtonEnabled(false);
    }else if(!minLengthPassword){
            errMsg="At least minumum 8 characters";
            setIsButtonEnabled(false);
    }else{
        errMsg="";
        setIsButtonEnabled(true);
    }

    setConfirmPasswordError(errMsg);    
  };

    const onClickLogin = async () => {             
        handleSubmit(async (password: IForcePassword) => {
            setLoading(true); 
            if (password?.NewPassword != password?.ConfirmNewPassword) {
                setConfirmPasswordError("Confirm password is not matched");
                setLoading(false);
                return;
            } 
            else
            {
                setConfirmPasswordError("");
            }
            password.Email = user?.email ?? '';
            password.UserId = user?.id ?? '';
            let status = await ForcePassword(password);
            setLoading(false);
            if (status && status=="Success") {
                message(NotifyType.Success, "Password Updated Successfully");
                window.location.href = '/eservices/';
              } else {           
                message(NotifyType.Error, "User Authentication failed. Please try again.")
            }
        })()
    }
      return (
        <>
          <Contaier>
            <div className="inner-content">
              <div className="container">
                <div className="landing-page form-upload">
                  <div className="row justify-content-center">
                    <div className="col-md-7 col-lg-5">
                      <div className="landing-list py-5 rounded-4">
                        <h2 className="text-center mb-5">Change Password</h2>
                        <div className="mb-3">
                          <label
                            htmlFor="validationServer01"
                            className="form-label"
                          >
                            Current Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Current Password"
                            id="CurrentPassword"
                            {...register("CurrentPassword", {
                              required: "Please enter current password",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="CurrentPassword"
                            render={({ message }) => (
                              <p className="errorMsgPassword mb-0">{message}</p>
                            )}
                          />
                        </div>
                        <div className="mb-3">
                          <label
                            htmlFor="validationServer02"
                            className="form-label"
                          >
                            Create New Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="New Password"
                            id="NewPassword"
                            {...register("NewPassword", {
                              required: "Please enter new password",
                              onChange(event) {
                                handleNewPasswordChange(event);
                              },
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="NewPassword"
                            render={({ message }) => (
                              <p className="errorMsgPassword mb-0">{message}</p>
                            )}
                          />
                          <p className="errorMsgPassword mb-0">
                            {newPasswordError}
                          </p>
                        </div>
                        <div className="mb-3">
                          <label
                            htmlFor="validationServer03"
                            className="form-label"
                          >
                            Confirm New Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="New Password"
                            id="ConfirmNewPassword"
                            {...register("ConfirmNewPassword", {
                              required: "Please enter confirm new password",
                              onChange(event) {
                                handleConfirmPasswordChange(event);
                              },
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="ConfirmNewPassword"
                            render={({ message }) => (
                              <p className="errorMsgPassword mb-0">{message}</p>
                            )}
                          />
                          <p className="errorMsgPassword mb-0">
                            {confirmPasswordError}
                          </p>
                        </div>
                        <div className="text-center">
                          <button
                            type="button"
                            disabled={!isButtonEnabled || loading}
                            onClick={onClickLogin}
                            className="btn btn-success mt-4"
                          >
                            {loading ? <Loader /> : <>Submit</>}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Contaier>
        </>
      );
}

export default ForceChangePassword;
